import SectionImageBokeh from '../../../assets/about/about-section-6-bokeh.png';
import SectionImage from '../../../assets/about/about-section-6-image.png';
import BokehAnimationBox from '../../../components/bokehAnimationBox/BokehAnimationBox';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';
import AboutTextBox from '../aboutTextBox/AboutTextBox';

import styles from './AboutCollectionSection.module.scss';

const AboutCollectionSection = ({ mainAnimationLoaded }: { mainAnimationLoaded: boolean }) => {
  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <div className={styles['section-images-container']}>
          <ScrollInAnimationItem className={styles['section-nfts-container']} delay="0.1s">
            <img
              alt=""
              className={styles['section-image']}
              src={mainAnimationLoaded ? SectionImage : ''}
              width="606"
              height="472"
            />
            <img
              alt=""
              className={styles['bokeh']}
              src={mainAnimationLoaded ? SectionImageBokeh : ''}
              width="787"
              height="670"
            />
            <BokehAnimationBox secondary className={styles['bokeh-animation-box']} />
            <div className={`pulse-animation ${styles['section-image-gradient']}`}></div>
          </ScrollInAnimationItem>
        </div>
        <ScrollInAnimationItem className={styles['textbox-container']} delay="0.2s">
          <AboutTextBox
            dark
            className={styles['textbox']}
            caption={
              <>
                collection of <b>2000</b> nfts
              </>
            }
            content={
              <>
                <p>
                  The initial collection will consist of 2000 NFTs separated into countries, cities, and world-famous
                  buildings. Each NFT will have its high-quality 3D model and we are trying to ensure that we can
                  legally operate in the metaverse with building IP’s.ach NFT will have a product page with full
                  description, key metrics about the royalties generated from different sources, leaderboard metrics on
                  the building's popularity, information on the top shareholders, price history, current listing, and
                  upcoming events.
                </p>
              </>
            }
            animationType={ScrollAnimationType.slideInBottom}
            captionDelay="0.3s"
            contentDelay="0.4s"
          />
        </ScrollInAnimationItem>
      </div>
    </div>
  );
};

export default AboutCollectionSection;
